var _defs, _path, _circle, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLabel = function SvgLabel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".label_svg__a{fill:none;stroke:currentColor;stroke-linejoin:round;stroke-linecap:round}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.342 7.212a2.82 2.82 0 0 0 .7-1.714v-4a1 1 0 0 0-1-1l-4.258.007a2.8 2.8 0 0 0-1.707.708L1.249 12.041a1 1 0 0 0 0 1.414l4.836 4.836a.99.99 0 0 0 1.407-.007Z",
    className: "label_svg__a"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.542,
    cy: 3.998,
    r: 1.5,
    className: "label_svg__a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m15.242 22.3-4.2 1.2 1.2-4.2 7.179-7.179a2.121 2.121 0 0 1 3 3Z",
    className: "label_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m18.521 13.019 3 3",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinejoin: "round"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m12.242 19.298 3 3",
    className: "label_svg__a"
  })));
};
export default SvgLabel;